import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/ajax.service";
import * as i2 from "Angular/services/core/urls.service";
/**
 * NotesService.
 *
 * This service has data access functions for Notes related resources.
 */
export class SecurityNotesService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    /**
     * Returns the notes for a security.
     *
     * @param securityId: Security ID.
     * @param securityType: Security Type.
     */
    getNotes(id, type) {
        const getNotesUrl = this.urlsService.getUrl(this.urlsService.NOTES.SECURITY_NOTE_COLLECTION, {
            securityId: id,
            securityType: type,
        });
        return this.ajaxService.getDataObserveBody(getNotesUrl);
    }
    /**
     * Creates a new Note for a security.
     *
     * @param securityId: Security ID.
     * @param securityType: Security type.
     * @param noteText: Note's text content.
     */
    createNote(id, noteText, type) {
        return this.ajaxService.postFormEncodedDataObserveBody(this.urlsService.NOTES.NOTE_COLLECTION, {
            note_content: noteText,
            security_id: id,
            security_type: type,
        });
    }
    /**
     * Deletes a Note with the given ID.
     *
     * @param noteId: Note ID.
     */
    deleteNote(id) {
        const deleteUrl = this.urlsService.getUrl(this.urlsService.NOTES.NOTE_ITEM, { noteId: id });
        return this.ajaxService.deleteDataObserveBody(deleteUrl);
    }
    /**
     * Updates a Note text content.
     *
     * @param noteId: Note ID.
     * @param noteText: Note text content.
     */
    updateNote(noteId, noteText) {
        const putUrl = this.urlsService.getUrl(this.urlsService.NOTES.NOTE_ITEM, { noteId });
        return this.ajaxService.putDataObserveBody(putUrl, { note_content: noteText });
    }
}
SecurityNotesService.ɵfac = function SecurityNotesService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SecurityNotesService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
SecurityNotesService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SecurityNotesService, factory: SecurityNotesService.ɵfac, providedIn: 'root' });
